export default __webpack_public_path__ + "static/media/mac-now-logo.4f6f7821.svg";